import { graphql } from "@/gql";

export const CHECK_IN_UPDATES_SUBSCRIPTION = graphql(`
  subscription CHECK_IN_UPDATES_SUBSCRIPTION($organizationId: String!) {
    checkInUpdates(input: { organizationId: $organizationId }) {
      checkIn {
        id
        shortId
        createdAt
        coordinates {
          x
          y
        }
        member {
          id
          displayName
          fullName
          avatarUrl
        }
        organizationId
        organization {
          id
          name
          logoUrl
        }
      }
      event
      relatedIds
    }
  }
`);
